import { Navigate, Route, Routes } from 'react-router-dom'
import LoginPage from './pages/LoginPage'
import AdminHome from './pages/AdminHome'
import AdminReportes from './pages/AdminReportes'
import AdminTarifas from './pages/AdminTarifas'
import AuxiliarDashboard from './pages/AuxiliarDashboard'
import CafeteriaCajero from './pages/CafeteriaCajero'
import ChefDashboard from './pages/ChefDashboard'
import CocinaKDS from './pages/CocinaKDS'
import EnfermeriaIndicacion from './pages/EnfermeriaIndicacion'
import EnfermeriaIndicacionMatriz from './pages/EnfermeriaIndicacionMatriz'
import JefeCocinaDashboard from './pages/JefeCocinaDashboard'
import NutricionistaCatalogo from './pages/NutricionistaCatalogo'
import NutricionistaReportes from './pages/NutricionistaReportes'
import RecepcionCuentasAbiertas from './pages/RecepcionCuentasAbiertas'
import { useAuth } from './hooks/useAuth'

function ProtectedRoute({ children, roles }: { children: JSX.Element; roles?: string[] }) {
  const { user } = useAuth()
  if (!user) return <Navigate to="/login" replace />
  if (roles && !roles.includes(user.rol)) return <Navigate to="/" replace />
  return children
}

function rutaPorDefectoSegunRol(rol: string): string {
  switch (rol) {
    case 'cocinera':
      return '/cocina'
    case 'enfermera':
      return '/enfermeria'
    case 'chef':
    case 'jefe_cocina':
    case 'chef_corporativo':
      // Default va al ChefDashboard (Fase B-C: compras/recetas/inventario).
      // /jefe-cocina (F11 escalacion) sigue accesible escribiendo la URL.
      return '/chef'
    case 'nutricionista':
    case 'nutricionista_corporativa':
      return '/nutricionista'
    case 'admin':
      // El admin aterriza en su panel de navegación, no en la pantalla
      // del auxiliar (que vacía se presta a confusión).
      return '/inicio'
    default:
      return '/auxiliar'
  }
}

export default function App() {
  const { user } = useAuth()
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/inicio"
        element={
          <ProtectedRoute roles={['admin']}>
            <AdminHome />
          </ProtectedRoute>
        }
      />
      <Route
        path="/auxiliar"
        element={
          <ProtectedRoute roles={['auxiliar', 'admin']}>
            <AuxiliarDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cocina"
        element={
          <ProtectedRoute roles={['cocinera', 'admin']}>
            <CocinaKDS />
          </ProtectedRoute>
        }
      />
      <Route
        path="/enfermeria"
        element={
          <ProtectedRoute roles={['enfermera', 'admin']}>
            <EnfermeriaIndicacion />
          </ProtectedRoute>
        }
      />
      <Route
        path="/enfermeria/matriz"
        element={
          <ProtectedRoute roles={['enfermera', 'admin']}>
            <EnfermeriaIndicacionMatriz />
          </ProtectedRoute>
        }
      />
      <Route
        path="/chef"
        element={
          <ProtectedRoute roles={['chef', 'jefe_cocina', 'chef_corporativo', 'admin']}>
            <ChefDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/jefe-cocina"
        element={
          <ProtectedRoute roles={['jefe_cocina', 'chef_corporativo', 'admin']}>
            <JefeCocinaDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/nutricionista"
        element={
          <ProtectedRoute roles={['nutricionista', 'nutricionista_corporativa', 'admin']}>
            <NutricionistaCatalogo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/nutricionista/reportes"
        element={
          <ProtectedRoute roles={['nutricionista', 'nutricionista_corporativa', 'admin']}>
            <NutricionistaReportes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/reportes"
        element={
          <ProtectedRoute roles={['admin']}>
            <AdminReportes />
          </ProtectedRoute>
        }
      />
      {/* Sprint 9 (plan 12-jun) — C3 tarifas + C4 cafeteria + C5 recepcion */}
      <Route
        path="/admin/tarifas"
        element={
          <ProtectedRoute roles={['admin', 'nutricionista', 'nutricionista_corporativa']}>
            <AdminTarifas />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cafeteria"
        element={
          <ProtectedRoute roles={['auxiliar', 'admin']}>
            <CafeteriaCajero />
          </ProtectedRoute>
        }
      />
      <Route
        path="/recepcion/cuentas"
        element={
          <ProtectedRoute roles={['auxiliar', 'admin']}>
            <RecepcionCuentasAbiertas />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={
          user ? (
            <Navigate to={rutaPorDefectoSegunRol(user.rol)} replace />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      {/* Tanda 6 (5-jul): sin catch-all, una URL con typo dejaba pantalla en
          blanco sin salida. Redirige al inicio del rol (o al login). */}
      <Route
        path="*"
        element={
          <Navigate to={user ? rutaPorDefectoSegunRol(user.rol) : '/login'} replace />
        }
      />
    </Routes>
  )
}
